import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { IOption } from 'ng-select';

@Injectable()
export class GdprService {
  constructor(private apiService: ApiService) { }

  getgdprdetail() {
    return this.apiService.get('/gdpr').map(data => data);
  }

  saveAnonymousRequest(data, appid) {
    return this.apiService.post('/gdpranonymountrequest/' + appid, data).map(data => data);
  }

  getgdpranonymousrequestlist(appId) {
    return this.apiService.get('/gdpranonymousrequestlist/' + appId).map(data => data);
  }

  getgdprcloserequestlist(appId) {
    return this.apiService.get('/gdprcloserequestlist/' + appId).map(data => data);
  }

  getgdpranonymousactivityrequestlist(id, type) {
    return this.apiService.get('/gdpractivityrequestlist/' + type + '/type/' + id).map(data => data);
  }

  saveAnonymousActivityRequestApprove(data, id) {
    return this.apiService.post('/gdpractivityrequestapprove/' + id, data).map(data => data);
  }

  sendLog(appId) {
    return this.apiService.get('/sendlog/' + appId).map(data => data);
  }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/gdrp-management/gdrp-management.ts